import React from 'react'

import {useIsJobDeleted} from '../../../../../../EditPipelinePage/EditPipelinePage.hooks'

import styles from './JobSettingsOverlay.css'

type Props = {
  jobId: string
}

function JobSettingsOverlay({jobId}: Props) {
  const isDeleted = useIsJobDeleted(jobId)

  return isDeleted ? <div className={styles.overlay} /> : null
}

export default JobSettingsOverlay
